<template>
  <div>

    <div class="bar_nav">
      <div class="title">移出成员</div>
      <div class="bar_back_btn" @click="goToGroupSetting">群组成员</div>
    </div>
    <div class="bar_empty"></div>

    <div class="user_list_item" v-for="user in filteredResult" :key="user.id" :title="user.fullName" :value="user.id">
      <div class="user_avatar">
        <img :src="user.avatarCdnUrl" alt="" v-if="user.avatar">
        <img src="../assets/avatar.png" alt="" v-if="!user.avatar">
        <div class="circle_border"></div>
      </div>
      <div class="user_name">{{user.fullName}}</div>
      <div class="btn btn_del" @click="removeUserFromGroup(user.id)">移出群</div>
    </div>

    <div class="user_list_item" v-for="user in groupNoUsers" :key="user.id">
      <div class="user_avatar">
       
        <img src="../assets/avatar.png" alt="">
        <div class="circle_border"></div>
      </div>
      <div class="user_name">{{user.mobilePhone}}（未注册）</div>
      <div class="btn btn_del" @click="removeUserFromNoUserGroup(user.id)">移出群</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'RemoveMember',
  data: function () {
    return {
      groupNoUsers: [],
      userList: [],
      filteredResult: [],
      mobilePhone: '',
      isSearching: false
    }
  },
  watch: {
    mobilePhone: function() {
      this.filteredResult = this.userList.filter(u => u.mobilePhone === this.mobilePhone)
    }
  },
  async created() {
    try {
      this.userList = (await this.$faApi.getGroupMembers(this.$route.params.groupId)).data
      this.groupNoUsers = (await this.$faApi.getGroupNoUsers(this.$route.params.groupId)).data
      this.filteredResult = this.userList
    } catch (err) {
      this.$faLogger.error('RemoveMember.vue:created', err)
    }
  },
  methods: {
    async removeUserFromNoUserGroup(id) {
      try {
        await this.$faApi.removeUserFromNoUserGroup(id)
        this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
      } catch (err) {
        this.$faLogger.error('RemoveMember.vue:btn_remove', err)
      }
    },
    async removeUserFromGroup(userId) {
      try {
        await this.$faApi.removeUserFromGroup(this.$route.params.groupId, userId)
        this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
      } catch (err) {
        this.$faLogger.error('RemoveMember.vue:btn_remove', err)
      }
    },
    async goToGroupSetting() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
  